<!--
 * @Description: 
 * @Date: 2021-12-14 11:43:30
-->
<template>
  <div class="apply">
    <h1>温馨提示</h1>
    <ul>
      <li v-for="item in list" :key="item">
        {{ item }}
      </li>
    </ul>
    <div class="apply__agreement">
      <van-checkbox shape="square" v-model="checked">
        我已阅读并同意
      </van-checkbox>
      <router-link
        style="color:#2F7DFB;margin-left:.13rem"
        tag="span"
        :to="{ name: 'PersonalLogOffAgreement' }"
      >
        账号注销协议
      </router-link>
    </div>
    <van-button
      type="primary"
      color="#5494FC"
      block
      style="margin-top:.64rem"
      :disabled="!checked"
      @click="onApply"
    >
      申请注销
    </van-button>
  </div>
</template>

<script>
export default {
  name: 'PersonalLogOffApply',
  data() {
    return {
      list: [
        '注销后,账号下的全部权益将被清除',
        '注销后,账号下的所有数据、记录等将无法访问和找回',
        '账号一旦注销完成,将无法恢复',
        '账号注销不需要审核,一旦申请即刻完成'
      ],
      checked: false
    };
  },
  components: {},
  watch: {},
  computed: {},
  methods: {
    onApply() {
      if (this.checked) {
        this.$router.push({ name: 'PersonalLogOffConfirm' });
      }
    }
  },
  created() {},
  beforeDestroy() {}
};
</script>

<style scoped lang="scss">
@import '@/style/mixins.scss';
.apply {
  padding: 0 0.8rem;
  padding-top: 1.47rem;
  h1 {
    font-size: 0.43rem;
    text-align: center;
    margin-bottom: 0.8rem;
  }
  ul {
    li {
      font-size: 0.37rem;
      margin-bottom: 0.87rem;
      position: relative;
      padding-left: 0.55rem;
      &::after {
        content: ' ';
        width: 0.16rem;
        height: 0.16rem;
        border-radius: 50%;
        background-color: #2f7dfb;
        position: absolute;
        top: 0.32rem;
        left: 0;
      }
      &:last-child {
        margin-bottom: 0;
      }
    }
  }
  &__agreement {
    margin-top: 1rem;
    display: flex;
    align-items: center;
    line-height: 1;
  }
}
</style>
